(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('useful-links', {
            parent: 'app',
            url: '/useful-links',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/useful-links/useful-links.html',
                    controller: 'UsefulLinksController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('useful-links');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
